import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { activeCategory } from 'components/hotelCategory/reducer'
import { sidebar } from 'components/slidingpane/reducer'
export default configureStore({
  reducer: combineReducers({
    activeCategory,
    sidebar
  }),
})